import axios from '@/api/axios';
import * as s_Interface from '@/interface/store/auth';

export const emailCheck = (email: s_Interface.EmailPayload) =>
  axios.post(`/auth/email-check`, email);
export const register = (payload: s_Interface.RegisterPayload) =>
  axios.post(`/auth/register`, payload);
export const registerInvite = (payload: s_Interface.RegisterPayload, code: string) =>
  axios.post(`/auth/invite/${code}`, payload);
export const code = (queryString: string) => axios.get(`/auth/register/${queryString}`);
export const login = (payload: s_Interface.LoginPayload) => axios.post(`/auth/login`, payload);
export const logout = () => axios.get(`/auth/logout`);
export const forgot = (payload: s_Interface.EmailPayload) => axios.post(`/auth/forgot`, payload);
export const setForgotPassword = (payload: { newPassword1: string; newPassword2: string }) =>
  axios.put(`/auth/forgot`, payload);
export const getForgotPassword = (code: string) => axios.get(`/auth/forgot/${code}`);
export const memberInvite = (code: string) => axios.get(`/auth/invite/${code}`);
